import { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { useProjectMethods, useProjectVariables } from "../context/ProjectContext";
import axios from "axios";

import { MainDiv, Item, Search, Tab } from "../component/index";
import loadingImg from "../asset/img/loading.gif";

import "../asset/style/Portfolio.css";

function Portfolio() {
  const [pageNum, setPageNum] = useState(1);
  const [pageQuery, setPageQuery] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [res, setRes] = useState(null);
  const {keyword, in_content, type}= useProjectVariables();
  const {setKeyword}= useProjectMethods();
  let isSearch = pageQuery.get("search") || false;

    useEffect(() => {
      let pn = pageQuery.get("page") || 1;
      setPageNum(pn);
    }, [pageQuery]);

  useEffect(()=>{
    setLoading(true);

    let resp;
    let metadata = {
      mode: "no-cors",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      validateStatus: (status)=> status <= 500 // Resolve only if the status code is less than 500
    };

    try {
      (async ()=>{
        if(isSearch){
          metadata.params= {
            limit: 5,
            page: pageNum,
            keyword: keyword,
            in_content: in_content
          }
          resp= await axios.get(process.env.REACT_APP_API_BE_URL + "/api/v1/projects/search", metadata);
        }else{
          metadata.params= {
            limit: 5,
            page: pageNum,
            type: type
          }
          resp= await axios.get(process.env.REACT_APP_API_BE_URL + "/api/v1/projects", metadata);
        }
        setRes(resp);
        setLoading(false);
      })();
    } catch (err) {
      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(err.response);
      }
      setRes(null);
      setLoading(false);
    }
    
  }, [pageNum, isSearch, type, in_content, keyword]);

  let result,pagination, status;
  if(res !== null){
    status = res.status;
    result= res.data.projects !== undefined ? res.data.projects: undefined;
    pagination = res.data.pagination !== undefined ? res.data.pagination: undefined;
  }else{
    result= undefined;
    pagination= undefined;
    status= undefined;
  }

  const handleNavigation= (e, n)=>{
    e.preventDefault();
    if(isSearch) setPageQuery({ page: n, search: true });
    else setPageQuery({page: n});
    setLoading(true);
  }

  const handleReset= (e)=>{
    navigate("/portfolio");
    setKeyword("");
    setLoading(true);
  }

  let listProjects;
  if (status===200) listProjects = result.map((project) => (
      <Item data={project} key={project.id} />
    ));
  else if (status===404 && !isSearch) listProjects = (
      <span className="info">
        Apologies, projects are not available now. Check back later.
      </span>
    );
  else if (status===404 && isSearch) listProjects = (
    <span className="info">
      No matching result.
    </span>
  );
  else if(status===500 && !isSearch) listProjects = (<span className="error">An error occured, Try again later.</span>);

  return (
    <MainDiv>
      <h1>Portfolio</h1>
      <p>
        Explore my projects to see how I blend creativity and technical
        expertise to deliver high-quality solutions that meet diverse needs.
      </p>
      <Search />
      <div className="repo_type_notice">
        <p><FontAwesomeIcon icon={faLock} className="tech-icon" /> <Link to="/contact">Contact me</Link> to access any private project repository.</p>
        <p><FontAwesomeIcon icon={faLockOpen} className="tech-icon" /> Public project repositories are available on my <a href={"https://github.com/"+process.env.REACT_APP_GH_USERNAME} target="_blank" rel="noreferrer">Github page.</a></p>
      </div>
      { !isSearch && (<Tab />)}
      <div>
        {loading ? (
          <img src={loadingImg} alt="Loading..." className="loadingGif" />
        ) : (
          listProjects
        )}
      </div>
      {pagination !== undefined && status===200 && (
          <div className="pagination-btn-panel">
            {pagination.first !== undefined && (<button onClick={(e)=> handleNavigation(e, pagination.first)}>{`${pagination.first}`}</button>)}
            <button disabled={pagination.prev === undefined} onClick={(e)=> handleNavigation(e, pagination.prev)}>Previous</button>
            <button disabled={pagination.next === undefined} onClick={(e)=> handleNavigation(e, pagination.next)}>Next</button>
            {pagination.last !== undefined && (<button onClick={(e)=> handleNavigation(e, pagination.last)}>{`${pagination.last}`}</button>)}
          </div>
      )}
      {isSearch && (<button onClick={handleReset} className="button">View other project</button>)}
    </MainDiv>
  );
}

export default Portfolio;